import { useMemo, useState, useRef } from "react";
import UIkit from "uikit";
import { EMOJI_CATEGORIES } from "../../ui/emojiData";

export default function EmojiPicker({ onSelect }) {
  const [query, setQuery] = useState("");
  const dropdownRef = useRef(null);

  const filteredCategories = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return EMOJI_CATEGORIES;

    return EMOJI_CATEGORIES
      .map(cat => {
        const items = cat.items.filter(item => {
          const text = [
            item.emoji,
            ...(item.keywords || [])
          ]
            .join(" ")
            .toLowerCase();

          return text.includes(q);
        });

        return { ...cat, items };
      })
      .filter(cat => cat.items.length > 0);
  }, [query]);

  const handleSelect = (emoji) => {
    onSelect?.(emoji);

    // close dropdown
    if (dropdownRef.current) {
      UIkit.dropdown(dropdownRef.current)?.hide(false);
    }

    setQuery("");
  };

  return (
    <div
      ref={dropdownRef}
      data-uk-dropdown="mode: click; pos: top-left; offset: 8"
      className="emoji-picker uk-card uk-card-default uk-padding-small"
      style={{ width: 500 }}
    >
      <div className="uk-margin-bottom">
        <input
          className="uk-input uk-form-small"
          type="text"
          placeholder="Search emoji (e.g. thanks, key, clean)"
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={e => e.stopPropagation()}
        />
      </div>

      <div className="emoji-scroll uk-overflow-auto" style={{ maxHeight: 400 }}>
        {filteredCategories.map(category => (
          <div key={category.key} className="uk-margin-bottom">
            <div className="emoji-category-header">
              {category.label}
            </div>

            <div className="emoji-grid">
              {category.items.map(item => (
                <button
                  key={item.emoji}
                  type="button"
                  className="emoji-btn"
                  onClick={() => handleSelect(item.emoji)}
                >
                  {item.emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}